import styled from 'styled-components';

const TitleCmp = styled.h1`
  color: ${({ theme }) => theme && theme.text ? theme.text.primary : '#fff'};
  margin: 1rem 0;
  background-color: ${({ theme }) => theme && theme.background ? theme.background.overlay : '#fff'};
  border-radius: 50px;
  padding: 1rem;
  ${({ arrow }) => arrow ? 'cursor: default;' : ''}
`;

export default TitleCmp;
